/* Tidies what visitors type into the forms that post straight to Shopify
   (contact, reviews, newsletter, blog comments, cart note, Artist
   Collaboration) before it leaves the page. A form opts in with
   data-pf-guard. On every edit and again on submit each text field is
   cleaned: control and invisible formatting characters out, anything
   tag-shaped out, whitespace collapsed (newlines kept in textareas), trimmed,
   cut to its maxlength. The field's own limits (required, minlength,
   maxlength, pattern, type) are then re-checked, so a value that only became
   invalid after cleaning — say, a name that was nothing but a <script> tag —
   is stopped here rather than sent.

   ponytail: client-side only. Anyone can still POST to /contact directly;
   Shopify's hCaptcha and its escaping of submissions are the server-side
   guard, and these forms have no server of ours to validate on. */
(function () {
  /* C0/C1 controls except tab, newline and carriage return; zero-width space;
     bidi embeddings, overrides and isolates (used to disguise text in mail
     clients); byte-order mark. ZWJ/ZWNJ stay: Indic scripts and emoji need them. */
  var INVISIBLE = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F​‪-‮⁦-⁩﻿]/g;
  var TAG = /<\/?[a-z!?][^<>]*>/gi;
  var TEXT = /^(text|email|url|tel|search)$/;

  function clean(el) {
    var area = el.tagName === 'TEXTAREA';
    if (!area && !TEXT.test(el.type)) return;
    var v = el.value.normalize('NFC').replace(INVISIBLE, '').replace(TAG, '');
    v = area ? v.replace(/[^\S\n]+/g, ' ').replace(/ *\n */g, '\n').replace(/\n{3,}/g, '\n\n') : v.replace(/\s+/g, ' ');
    v = v.trim();
    if (el.maxLength > 0 && v.length > el.maxLength) v = v.slice(0, el.maxLength);
    if (v !== el.value) el.value = v;
  }

  function guarded(form) {
    return form && form.hasAttribute && form.hasAttribute('data-pf-guard');
  }

  document.addEventListener('change', function (e) {
    if (guarded(e.target.form)) clean(e.target);
  }, true);

  /* Capture phase on document runs before any listener on the form itself
     (Shopify's captcha included), so they all see the cleaned values. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!guarded(form)) return;
    for (var i = 0; i < form.elements.length; i++) clean(form.elements[i]);
    if (!form.noValidate && !form.checkValidity()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      form.reportValidity();
    }
  }, true);
})();
